<template>
  <!-- Switch Container -->
  <span
    :class="`flex items-center rounded-full px-1 ${
      size === 'sm' ? 'w-11 h-6' : 'w-14 h-7'
    } ${
      value
        ? disabled
          ? 'bg-cyan-600 cursor-not-allowed'
          : 'bg-cyan-700'
        : 'bg-gray-300'
    }`"
    role="checkbox"
    tabindex="0"
    :aria-checked="value && value.toString()"
    @click="toggle"
    @keydown.space.prevent="toggle"
  >
    <!-- Switch -->
    <span
      :class="`
        bg-white
        rounded-full
        shadow-md
        transition-all
        duration-200
        ease-in-out
        transform ${size === 'sm' ? 'w-4 h-4' : 'w-5 h-5'} ${
        value && size === 'sm' && 'translate-x-5'
      } ${value && size !== 'sm' && 'translate-x-7'}
      `"
    ></span>
  </span>
</template>

<script>
export default {
  name: 'ToggleInput',
  props: ['value', 'size', 'disabled'],

  methods: {
    toggle() {
      if (this.disabled) return
      this.$emit('input', !this.value)
    },
  },
}
</script>
